<template>
    <!--LEFT SIDEBAR-->
    <div class="aside-column">

      <nav class="page-menu backlit-menu">
        <template v-if="helpMenuLoaded">
          <template v-for="item in helpMenu.items">
            <router-link activeClass="active" :to="'/help/' + item.id + '/'" class="page-menu-link">{{ getMenuItemName(item) }}</router-link>
          </template>

        </template>
      </nav>
      <a class="btn btn-slim w-100" :href="currentHelpSettings.pdf_file" download>
        <svg class="svg-download">
          <use href="/img/sprite.svg#svg-download"></use>
        </svg>
        <span>{{ currentHelpSettings.download_pdf }}</span>
      </a>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  data: () => ({

  }),
  async created() {
    this.fetchHelpMenu();
    
  },
  computed: {
    ...mapGetters('helpMenu', [
      'helpMenu',
      'helpMenuLoading',
      'helpMenuError',
      'helpMenuLoaded',
    ]),
    ...mapGetters([
      'lang'
    ]),
    ...mapGetters('app', [
      'helpSettings'
    ]),
    currentHelpSettings() {
      return this.helpSettings[this.lang] || {};
    }
  },
  methods: {
    ...mapActions('helpMenu', [
      'fetchHelpMenu',
    ]),
    getMenuItemName(item) {
      if (item.id === 'faq') {
        return this.currentHelpSettings.faq_title || 'FAQ';
      }

      return item[this.lang]?.name || '';
    },

  }
}
</script>
